/***
 * 创建人：zll
 * 时间：2020-10-9
 * 描述：动态表单关联组织功能
 * 更新说明:
 */
import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef, Renderer2, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SwJwtService } from "src/app/librarys/serves/sw-jwt.service";
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
declare var $: any;

@Component({
  selector: 'sw-dynamic-form-link-organize',
  templateUrl: './sw-dynamic-form-link-organize.component.html',
  styleUrls: ['./sw-dynamic-form-link-organize.component.css']
})
export class SwDynamicFormLinkOrganizeComponent implements OnInit {

  organizeModel = [];//组织
  organizeId: string = ''; //选中组织id
  headerLoGo:string="部门";
  @ViewChild('modal') modal: SwModalframeComponent; //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //保存事件
  paramName: string=""
  constructor(
    private box: SwMassageBoxService, //消息提示服务
    private service: BdpService, //请求服务
    private systemId:SystemIdService,
    private jwt: SwJwtService, //session读取服务
    private el:ElementRef,
    private renderer2:Renderer2
  ) { }

  ngOnInit() {
    this.headerLoGo = this.param['name'] //标题
    this.paramName = this.param['name'] //label名称
    this.organizeModel = this.param['data'] //下拉树数据值
    this.organizeId = this.param['value'] //选中的值
  }

  ngAfterViewInit(): void {
  }

  //点击取消
  clickCancel() {
    let val = {code:false,data:[]}
    this.modal.toggle()
    this.callback.emit(val)
  }
  //点击确定
  confirmData() {
    // let checkedText = ''
    // this.organizeModel.forEach(val=>{
    //  if(val.organizeId == this.organizeId){
    //   checkedText = val.organizeName
    //  }
    // })
    let val = {code:true,data:{paramCode:this.param['code'],paramValue:this.organizeId}}
    this.modal.toggle()
    this.callback.emit(val)
  }
 
}
